export class SearchFacetRangeQuery {
  public excludedFacet: boolean;
  public query: string;

  constructor(
    public field: string,
    public fromValue: string,
    public toValue: string,
    public facetLabel: string,
    public label: string,
    public value: string,
    public token: string
  ) {
    this.query = field + ':[' + fromValue + ' TO ' + toValue + ']';
  }
}
